<template>
    <div class="ruleset-tree-wrapper">
      <h2>{{ $t('Rulesets.Title') }}</h2>
      <div class="infos">
      <span style="padding-top: 5px;" class="material-symbols-outlined">info</span>
      <div>
      <p>{{ $t('Rulesets.P1') }}</p>
      <p>{{ $t('Rulesets.P2') }}</p>
      <p>{{ $t('Rulesets.P3') }}</p>
      <p>{{ $t('Rulesets.P4') }}</p>
    </div>
    </div>
    <div class="button-group" >
      <div 
        class="deviceButton deviceComputer" 
        :class="{ active: rulesetsOnly == false }" 
        @click="rulesetsOnly = false"
      >
        <span class="material-icons">account_tree</span>
    </div>
      <div 
        class="deviceButton devicePhone" 
        :class="{ active: rulesetsOnly == true }" 
         @click="rulesetsOnly = true"
      >
        <span class="material-icons">rule</span>
      </div>
    </div>
    <div class="rulesetBackground">
      <!-- Übergibt die generierten treeData an die RulesetTree Komponente -->
       <div v-if="treeData.length == 0"><em>{{ $t('Rulesets.errorNoData') }}</em></div>
      <RulesetTree :treeData="treeData" :highlightedId="highlightedId" :level="0" />
    </div>
    </div>
  </template>
  
  <script>
  import { mapGetters } from 'vuex';
  import RulesetTree from './Reusables/RulesetTree.vue';
  
  export default {
    components: {
      RulesetTree,
    },
    data() {
      return {
        rulesetsOnly: false, //changes tree depending on setting
        treeData: [], // Hier speichern wir die generierten Baumdaten
        highlightedId: 'block-12345', // ID des Blocks, der hervorgehoben wird (dies kann dynamisch sein)
      };
    },
    computed: {
      ...mapGetters(['getEmailData', 'getSharedData']),
      emailData() {
        return this.getEmailData;
      },
      currentId(){
        if (this.getSharedData?.id){
        return this.getSharedData.id
        } else {
          return 'block-12345'
        }
      }
    },
    methods: {
      // Diese Methode erstellt die Baumstruktur basierend auf emailData
      listRulesetBlocks(emailData) {
        const rulesetBlocks = [];
  
        // Rekursive Funktion, um alle Ruleset-Blöcke zu durchlaufen
        const traverseBlocks = (blockId, parentId = null, level = 0) => {
          const block = emailData[blockId];
          const condition = !this.rulesetsOnly ? block.type : block.type === 'Ruleset'
          if (!block) return;

          //if (block.type === 'Ruleset') {
          if (condition) {
            const node = {
              type: block.type,
              id: blockId,
              name: emailData[blockId].data.props?.name || `${block.type} Block Level ${level + 1}`, // Block-ID oder einen benutzerdefinierten Namen verwenden
              creationDate: emailData[blockId].creationDate || 'unknown',
              parentId: parentId,
              level: level,
              expanded: false,
              children: [],
            };
  
            // Durchlaufe die Kinder und füge sie dem Knoten hinzu
            if (block.data?.props?.childrenIds) {
              block.data.props.childrenIds.forEach(childId => {
                const childNode = traverseBlocks(childId, blockId, level + 1);
                if (childNode) node.children.push(childNode);
              })}
           /*  if (block.type == 'ColumnsContainer' && block.data?.props?.columns) {
              block.data.props.columns.forEach(column => {
                const childId = columnchildrenIds
                console.log(childId)
                const childNode = traverseBlocks(childId, blockId, level + 1);
                if (childNode) node.children.push(childNode);
              })
              ;
            } */
            if (block.type == 'ColumnsContainer' && block.data?.props?.columns) {
              block.data.props.columns.forEach(column => {
              if (column.childrenIds) {
                column.childrenIds.forEach(childId => {
                const childNode = traverseBlocks(childId, blockId, level + 1);
                if (childNode) node.children.push(childNode);
                });
              }
              });
            }
            return node; // Gibt den Knoten zurück
          }
        };
  
        // Beginne bei den Root-Blöcken und durchlaufe das Baumdiagramm
        if (emailData.root?.data.childrenIds) {
          emailData.root.data.childrenIds.forEach(blockId => {
            const blockNode = traverseBlocks(blockId);
            if (blockNode) rulesetBlocks.push(blockNode);
          });
        }
        return rulesetBlocks; // Gibt die gesamte Baumstruktur zurück
      },
    }, 
    watch:{
    'emailData': {
      handler() {
        this.treeData = this.listRulesetBlocks(this.emailData);
      },
      deep: true, // Überwacht auch tief verschachtelte Änderungen
      immediate: true // Startet sofort beim Laden der Komponente
    },
    'rulesetsOnly': {
      handler() {
        this.treeData = this.listRulesetBlocks(this.emailData);
      },
      deep: true, // Überwacht auch tief verschachtelte Änderungen
      immediate: true // Startet sofort beim Laden der Komponente
    },
  },
    beforeMount() {
      this.treeData = this.listRulesetBlocks(this.emailData); // Baumdaten erzeugen
    },
  };
  </script>
  
  <style scoped>
  .ruleset-tree-wrapper {
    padding: 20px 100px;
    max-width: 100%;
    height: 100%;
    margin: 0 auto;
    background-color: #f9f9f9;
    position: relative; 
  }


  .infos{
    display: flex;
    align-items: top;
    text-align: left;
    margin: 20px auto;
    font-size: 12px;
    color: var(--primary-color)
  }

  .button-group {
    width: 100px;
    display: flex;
    align-items: center;
    position: absolute;
    top: 10px;
    right: 10px;
}

.deviceButton {
  flex: 1;
  padding: 10px;
  text-align: center;
  cursor: pointer;
  border: 1px solid #ccc;
  transition: background-color 0.3s;
}

.deviceButton:hover {
  background: rgb(241, 238, 238);
}

.deviceButton.active {
  background-color: #eeeeee;
}

.deviceComputer{
  border-top-left-radius: 15%;
  border-bottom-left-radius: 15%;
  border-right: none;
}

.devicePhone {
  border-top-right-radius: 15%;
  border-bottom-right-radius: 15%;
}

.rulesetBackground {
  background-color: white;
  padding-top: 10px;
  padding-bottom: 10px;
  border: 2px solid  #ccc;
  min-height: 300px;
}
  </style>
  